{
  "table": {
    "object": "Objeto",
    "type": "Tipo",
    "message": "Mensaje",
    "state": "Estado",
    "actions": "Acciones",
    "createdAt": "Creado",
    "client": "Cliente",
    "userFirstName": "Nombre del usuario",
    "userLastName": "Apellido del usuario",
    "date": "Fecha",
    "amount": "Importe",
    "accountType": "Tipo de cuenta",
    "ticker": "Ticker",
    "currency": "Moneda",
    "price": "Precio",
    "quantity": "Cantidad",
    "organization": "Organización",
    "processDate": "Fecha del proceso",
    "objectType": "Tipo de objeto",
    "effectiveDate": "Fecha de entrada en vigor",
    "settleDate": "Fecha de liquidación",
    "custodianAccountNumber": "Número de cuenta de custodio",
    "clientName": "Nombre del cliente",
    "transaction": "Transacción",
    "subTransaction": "Subtransacción",
    "cusip": "CUSIP",
    "transactionDesc": "Descripción de la transacción",
    "transactionType": "Tipo de transacción",
    "commission": "Comisión",
    "accruedInterest": "Intereses devengados",
    "securityType": "Tipo de seguridad",
    "custodian": "Custodio",
    "account": "Cuenta",
    "flags": "Marcadores",
    "systemUpdated": "Sistema actualizado",
    "externalUpdated": "Actualización externa"
  },
  "state": "Estado",
  "exportProgressTitleFlags": "Exportación de marcadores",
  "exportProgressTitleActivities": "Exportación de actividades",
  "transactionType": "Tipo de transacción",
  "symbol": "Símbolo",
  "custodianAccountNumber": "Número de cuenta de custodio",
  "type": "Tipo",
  "any": "Cualquiera",
  "perPage": "Elementos por página",
  "goTo": "Ir a",
  "tabs": {
    "flags": "Marcadores",
    "activities": "Actividades",
    "jobs": "Empleos"
  },
  "flagState": {
    "FLAGGED": "Marcados",
    "FIXED": "Listo",
    "ALL_FIXED": "Marcar como Listo",
    "ALL_RECONCILE": "Reconciliar todo",
    "ALL_FORCE_RECONCILE": "Forzar reconciliar todo",
    "TRIVIAL": "Trivial"
  },
  "activityState": {
    "CREATED": "Creado",
    "RECONCILED": "Reconciliado",
    "RECONCILE": "Reconciliar",
    "FORCE_RECONCILE": "Reconciliación forzada"
  },
  "jobEventType": {
    "RECONCILIATION": "RECONCILIACIÓN"
  },
  "jobState": {
    "ANY": "CUALQUIERA",
    "INITIATED": "INICIADO",
    "COMPLETED": "COMPLETADO",
    "FAILED": "FALLÓ"
  },
  "eventTable": {
    "eventType": "Tipo de evento",
    "jobName": "Nombre del empleo",
    "ranAt": "Se ejecutó en",
    "updatedAt": "Actualizado",
    "state": "Estado",
    "organization": "Organización",
    "action": "Acción"
  },
  "runReconciliation": {
    "title": "Ejecutar reconciliación",
    "reconcileActivities": "Actividades de reconocimiento",
    "updateCashAndHoldings": "Actualizar efectivo y activos",
    "reconCashAndHoldings": "Reconciliar efectivo y activos",
    "publishSnapshots": "Publicar instantáneas",
    "runReconcileToastMessage": "Reconciliación solicitada"
  },
  "accountSnapshot": {
    "security": "Seguridad",
    "systemQuantity": "Cantidad del sistema",
    "externalQuantity": "Cantidad externa",
    "diffQuantity": "Diferencia de cantidad",
    "systemPrice": "Precio del sistema",
    "externalPrice": "Precio externo",
    "diffPrice": "Diferencia de precio",
    "systemValue": "Valor del sistema",
    "externalValue": "Valor externo",
    "diffValue": "Diferencia de valor",
    "systemBookValue": "Valor contable del sistema",
    "externalBookValue": "Valor contable externo",
    "diffBookValue": "Diferencia del valor contable",
    "ledger": "Libro mayor",
    "transfers": "Transferencias",
    "tradeOrders": "Órdenes comeriales",
    "custodianActivities": "Actividades externas",
    "total": "Total"
  },
  "jobDetails": {
    "title": "Detalles adicionales para {{jobName}} ejecutado el {{ranAt}}"
  },
  "reconFlags": {
    "title": "Reconciliación",
    "summaryTitle": "Panel de resumen",
    "spotlight": {
      "negativeCash": {
        "title": "Efectivo Negativo"
      },
      "negativeHolding": {
        "title": "Posición Negativa"
      },
      "holdingsMismatch": {
        "title": "Discrepancia de Posiciones"
      },
      "moneyAvailableMismatch": {
        "title": "Discrepancia de Dinero Disponible"
      }
    },
    "totalFlags": "Total de marcadores",
    "totalFlagsHint": "MARCADOS en la organización",
    "unresolvedThreePlus": "Sin resolver por más de 3 días",
    "unresolvedThreePlusHint": "MARCADOS, creado hace más de 3 días",
    "severity": {
      "all": "Todos",
      "critical": "Crítico",
      "high": "Alto",
      "medium": "Medio",
      "low": "Bajo"
    },
    "severityLabel": {
      "CRITICAL": "Crítico",
      "HIGH": "Alto",
      "MEDIUM": "Medio",
      "LOW": "Bajo",
      "UNKNOWN": "Desconocido"
    },
    "filters": {
      "flagType": "Tipo de marcador",
      "category": "Categoría",
      "aging": "Antigüedad",
      "any": "Cualquiera",
      "agingOneDay": "1+ día(s)",
      "agingThreeDays": "3+ día(s)",
      "agingSevenDays": "7+ día(s)",
      "clearFilters": "Borrar filtros",
      "priority": "Prioridad"
    },
    "categories": {
      "snapshot": "Instantánea",
      "warning": "Advertencia",
      "cashHoldings": "Efectivo y Posiciones",
      "activity": "Actividad",
      "transfer": "Transferencia",
      "account": "Cuenta",
      "product": "Producto"
    },
    "flagTypes": {
      "NEGATIVE_CASH": "Efectivo negativo",
      "NEGATIVE_HOLDING": "Posición negativa",
      "DIFFERENT_HOLDINGS_V2": "Discrepancia de posiciones",
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": "Discrepancia de dinero disponible"
    },
    "searchPlaceholder": "Buscar por nombre de cliente",
    "searchHelp": "Muestra marcadores para hasta {{max}} cuentas que mejor coinciden. Reduzca su búsqueda si los resultados parecen incompletos.",
    "searchHelpAria": "Acerca de los límites de búsqueda de cuentas",
    "selection": {
      "count": "{{count}} excepciones seleccionadas",
      "selectAllOnPage": "Seleccionar todo en la página",
      "clear": "Borrar selección",
      "dismiss": "Descartar {{count}}",
      "dismissConfirmTitle": "¿Descartar {{count}} marcadores seleccionados?",
      "dismissConfirmBody": "Esto marcará los marcadores seleccionados como resueltos. Esta acción no se puede deshacer desde esta pantalla.",
      "dismissConfirmAction": "Descartar {{count}}",
      "resolve": "Resolver",
      "resolveConfirmTitle": "¿Resolver marcadores seleccionados?",
      "resolveConfirmBody": "Esto marcará el(los) marcador(es) seleccionado(s) como Resuelto(s) y los eliminará de la lista Activa. Esto no se puede deshacer desde esta pantalla.",
      "resolveConfirmAction": "Resolver"
    },
    "table": {
      "account": "Cuenta",
      "firstSeen": "Visto por primera vez"
    },
    "agingDays_one": "{{count}} día",
    "agingDays_other": "{{count}} días",
    "drawer": {
      "close": "Cerrar",
      "title": "Detalle del marcador",
      "fallbackTitle": "Detalles del marcador",
      "detailsHeading": "Detalles",
      "summary": {
        "type": "Tipo:",
        "account": "Cuenta:",
        "date": "Fecha:",
        "firstSeen": "Visto por primera vez:"
      },
      "followUpTask": "Crear tarea de seguimiento",
      "resolve": "Resolver",
      "resolveSuccess": "Marcador resuelto",
      "resolveError": "No se pudo resolver este marcador",
      "tabs": {
        "overview": "Resumen",
        "rawJson": "JSON sin procesar",
        "notes": "Notas"
      },
      "sections": {
        "issueSummary": "Resumen del problema",
        "flagSummary": "Resumen del marcador",
        "account": "Cuenta",
        "activity": "Actividad y transferencia de custodio",
        "systemIdentifiers": "Identificadores del sistema",
        "additional": "Detalles adicionales"
      },
      "fields": {
        "flagType": "Tipo de marcador",
        "objectType": "Tipo de objeto",
        "priority": "Prioridad",
        "created": "Creado",
        "state": "Estado",
        "custodianAcctShort": "N.º de cuenta de custodio",
        "accountStatus": "Estado de la cuenta",
        "transactionId": "ID de transacción",
        "subTransactionId": "ID de subtransacción",
        "financialProductId": "ID de producto financiero",
        "activityType": "Tipo",
        "activityStatus": "Estado",
        "firstSeen": "Visto por primera vez"
      },
      "internalNotesHeading": "Notas internas",
      "notesLabel": "Notas",
      "notesPlaceholder": "Añada notas sobre su investigación…",
      "notesSaved": "Notas guardadas",
      "notesSaveError": "No se pudieron guardar las notas",
      "discardDraftConfirmTitle": "¿Descartar nota sin guardar?",
      "discardDraftConfirmBody": "Tiene una nota que no se ha guardado. ¿Cerrar sin guardar?",
      "discardDraftConfirmAction": "Descartar y cerrar",
      "dismissSuccess": "Marcador descartado",
      "dismissError": "No se pudo descartar este marcador",
      "notesHistoryEmptyTitle": "Aún no hay notas",
      "notesHistoryEmptyReadOnlyTitle": "No hay notas para este marcador",
      "notesHistoryEmptyDescription": "Añada una nota para capturar contexto importante sobre este marcador.",
      "addNote": "Añadir nota"
    },
    "bulkDismissError": "No se pudieron descartar los marcadores seleccionados",
    "bulkDismissSuccess": "{{count}} marcadores descartados",
    "bulkDismissPartial": "{{failed}} de {{total}} marcadores no pudieron ser descartados",
    "bulkDismissNoFlaggedSelected": "Ninguno de los marcadores seleccionados puede ser descartado. Solo los marcadores señalados pueden resolverse desde esta vista.",
    "emptyTable": "Ningún marcador coincide con los filtros actuales.",
    "pagination": {
      "summary": "Mostrando {{start}}–{{end}} de {{total}} marcadores"
    },
    "flagState": {
      "FLAGGED": "Marcados",
      "FIXED": "Listo",
      "TRIVIAL": "Trivial"
    },
    "emptyTableHint": "Intente ajustar sus filtros o búsqueda.",
    "emptyTableNoResults": "No se encontraron marcadores.",
    "emptyTableNoData": "No hay datos disponibles.",
    "agingHelp": "Días desde que este problema fue <bold>observado por primera vez</bold> (Visto por primera vez). El marcador puede actualizarse diariamente cuando la reconciliación reemite el mismo problema; esto <bold>no</bold> restablece la antigüedad. Resuelva o descarte cuando esté solucionado.",
    "agingHelpAria": "Acerca de la columna de antigüedad",
    "searchError": "La búsqueda de clientes falló. Inténtelo de nuevo.",
    "bulkResolveError": "No se pudieron resolver los marcadores seleccionados",
    "bulkResolveSuccess": "{{count}} marcadores resueltos",
    "bulkResolvePartial": "{{failed}} de {{total}} marcadores no pudieron ser resueltos",
    "bulkResolveNoFlaggedSelected": "Ninguno de los marcadores seleccionados puede ser resuelto. Solo los marcadores activos pueden resolverse desde esta vista."
  },
  "flagGlossary": {
    "title": "Glosario de marcadores",
    "openGlossary": "Glosario",
    "backToFlags": "Volver a los marcadores",
    "searchPlaceholder": "Buscar marcadores",
    "loadError": "No se pudo cargar el glosario de marcadores. Inténtelo de nuevo.",
    "emptyTable": "Ningún marcador coincide con los filtros actuales.",
    "emptyTableHint": "Intente ajustar sus filtros o búsqueda.",
    "emptyTableNoResults": "No se encontraron marcadores.",
    "emptyTableNoData": "No hay datos disponibles del glosario de marcadores.",
    "emptyTableError": "No se pudieron cargar los marcadores.",
    "emptyTableErrorHint": "Algo salió mal. Inténtelo de nuevo.",
    "filters": {
      "category": "Categoría",
      "clearFilters": "Borrar filtros"
    },
    "kpi": {
      "total": "Total de marcadores disponibles",
      "totalHint": "Todos los tipos de marcadores en el glosario",
      "thresholded": "Marcadores con umbral",
      "thresholdedHint": "Marcadores que admiten umbrales de cantidad o porcentaje",
      "turnedOff": "Desactivados",
      "turnedOffHint": "Tipos de marcadores deshabilitados para esta organización"
    },
    "table": {
      "flagName": "Nombre del marcador",
      "description": "Descripción",
      "exampleTrigger": "Ejemplo de activación",
      "category": "Categoría",
      "actualPriority": "Prioridad actual",
      "actualThreshold": "Umbral actual",
      "defaultPriority": "Prioridad predeterminada",
      "defaultThreshold": "Umbral predeterminado"
    },
    "pagination": {
      "summary": "Mostrando {{start}}–{{end}} de {{total}} tipos de marcadores"
    },
    "entries": {
      "INVALID_BOOK_VALUE_AMOUNT": {
        "description": "Una actividad de cambio en los datos del custodio tiene una cantidad, precio y símbolo válidos, pero el importe del valor contable no tiene sentido para el tipo de transacción (una entrada de cambio debería tener un valor contable positivo; una salida de cambio debería tener uno negativo).",
        "exampleTrigger": "Una entrada de cambio para ABC tiene una cantidad de 10 y un precio, pero el valor contable es 0, nulo o falta en los datos del custodio."
      },
      "FEE_NOT_FOUND": {
        "description": "Aparece una actividad de comisión en la fuente del custodio, pero no se encontró ninguna transferencia de retiro de comisión coincidente en la plataforma.",
        "exampleTrigger": "Aparece una comisión de gestión de $25 en los datos del custodio, pero no existe ninguna transferencia de comisión correspondiente en la plataforma para conciliarla."
      },
      "FEE_AMOUNT_DIFFERENT": {
        "description": "La actividad de comisión del custodio no coincide con la actividad de comisión de la plataforma.",
        "exampleTrigger": "La comisión del custodio es de $125.00 y los retiros de comisiones de la plataforma suman $100.00."
      },
      "TRADE_NOT_FOUND": {
        "description": "Los datos del custodio tienen un registro de operación, pero la plataforma no tiene una entrada de operación correspondiente.",
        "exampleTrigger": "La actividad del custodio muestra una COMPRA de XYZ en la cuenta 123, pero la plataforma no tiene una operación correspondiente para igualarla."
      },
      "ACCOUNT_NOT_FOUND": {
        "description": "Una actividad o registro en los datos del custodio hace referencia a un número de cuenta que no existe en la plataforma donde se espera que se encuentre.",
        "exampleTrigger": "El custodio envía datos de operación para la cuenta 12345678, la cuenta 12345678 no existe dentro de la plataforma."
      },
      "TRANSFER_NOT_FOUND": {
        "description": "Aparece una actividad relacionada con la transferencia en los datos del custodio (o una liquidación entrante no tiene candidatos en curso), pero no se encontró ninguna transferencia coincidente en la plataforma.",
        "exampleTrigger": "El custodio registra una liquidación entrante de $10,000 y la cuenta/subcuenta en la plataforma no tiene ninguna transacción de transferencia externa SOLICITADA/EN PROCESO."
      },
      "UNKNOWN_ACTIVITY_TYPE": {
        "description": "Un código o tipo de actividad informado por el custodio o la plataforma no coincide con ningún tipo de actividad reconocido en la configuración de mapeo.",
        "exampleTrigger": "Los datos del custodio incluyen un código de actividad sin mapeo correspondiente a un tipo de actividad conocido en la plataforma."
      },
      "FINANCIAL_PRODUCT_NOT_FOUND": {
        "description": "Una actividad o posición hace referencia a un producto financiero (valor, fondo, etc.) que no está en el catálogo de productos de la plataforma.",
        "exampleTrigger": "Una operación hace referencia al CUSIP de valor 123456789, pero no existe ningún registro de producto financiero coincidente en el catálogo de la plataforma."
      },
      "NOT_CORPORATE_ACCOUNT": {
        "description": "Un tipo de actividad que solo se espera en cuentas corporativas se registró en una cuenta no corporativa en su lugar.",
        "exampleTrigger": "Se registra una actividad corporativa en una cuenta individual sujeta a impuestos en lugar de una cuenta corporativa."
      },
      "TOO_MANY_EXTERNAL_TRANSFER_IN_CANDIDATES_FOUND": {
        "description": "Más de una transferencia del custodio coincide con los detalles de una única transferencia entrante esperada, por lo que la plataforma no puede determinar automáticamente cuál se aplica.",
        "exampleTrigger": "Tres transferencias separadas del custodio coinciden con la misma referencia y importe de depósito, por lo que la plataforma no puede determinar automáticamente cuál se aplica."
      },
      "CURRENCY_IS_NOT_AVAILABLE": {
        "description": "Una actividad hace referencia a una moneda que no está habilitada o soportada para la cuenta en el custodio.",
        "exampleTrigger": "Una operación para la cuenta 12345678 está denominada en euros, pero esa moneda no ha sido habilitada para la conexión de la cuenta con el custodio."
      },
      "NSF_REBOOKING_DETECTED": {
        "description": "Se omite una actividad NSF porque coincide con un patrón de recontabilización del custodio: una reversión y un depósito emparejados del mismo importe se registran en la cuenta el mismo día (a menudo utilizado cuando el custodio corrige los códigos de contribuyente).",
        "exampleTrigger": "Un NSF de −$500 y un depósito de +$500 se registran en la misma cuenta el mismo día, por lo que el NSF se omite y se activa este marcador en su lugar."
      },
      "HBP_WITHDRAW_TRANSFER_NOT_FOUND": {
        "description": "Aparece una actividad de retiro HBP en los datos del custodio, pero no se encontró ningún retiro del Plan de Compra de Vivienda coincidente en la plataforma para esa cuenta.",
        "exampleTrigger": "Los datos del custodio muestran un retiro HBP de $35,000 en una cuenta REER, pero la plataforma no tiene ningún retiro del Plan de Compra de Vivienda coincidente para conciliarlo."
      },
      "EFT_ACTIVITY_NOT_FOUND": {
        "description": "Una actividad NSF hace referencia a una transacción anterior que no tiene ninguna actividad de retiro EFT o interna coincidente en los datos del custodio para esa cuenta y moneda.",
        "exampleTrigger": "Se recibe un NSF de −$1,200, pero no existe ninguna actividad de retiro EFT o interna coincidente para esa cuenta y moneda."
      },
      "TRANSFER_AMOUNT_DIFFERENT": {
        "description": "Un importe de liquidación entrante del custodio difiere en más de una tolerancia fija del 10% de cada candidato de transferencia externa en curso en la subcuenta. Dentro de esa tolerancia, la plataforma concilia automáticamente con el importe del custodio sin activar un marcador; fuera de ella, el emparejamiento automático está bloqueado.",
        "exampleTrigger": "Se recibe una liquidación de $10,000, pero el único candidato en curso es de $8,500 — una brecha del 15%, fuera de la tolerancia fija del 10% — por lo que la plataforma no puede igualarlo automáticamente y lo marca para reconciliación manual."
      },
      "TRANSFER_IMPORT_FAILED": {
        "description": "Un registro de transferencia del archivo de importación del custodio se marcó como fallido y no se importó correctamente a la plataforma.",
        "exampleTrigger": "Un registro de transferencia en el archivo de importación del custodio se marca como fallido, por lo que no se importa a la plataforma."
      },
      "TRANSFER_STUCK_PROCESSING": {
        "description": "Una transferencia iniciada por el usuario ha permanecido en estado de Procesamiento más allá del SLA de 2 días hábiles.",
        "exampleTrigger": "Un retiro pasó a estado de Procesamiento el lunes y sigue allí el miércoles, más allá del SLA de 2 días hábiles."
      },
      "TRANSFER_STUCK_INITIATED": {
        "description": "Un retiro iniciado por el usuario ha permanecido en estado Iniciado durante 3 días hábiles sin avanzar.",
        "exampleTrigger": "Un retiro entró en estado Iniciado hace 3 días hábiles y sigue allí sin progresar."
      },
      "TRANSFER_STUCK_READY": {
        "description": "Una transferencia iniciada por el usuario ha permanecido en estado Listo más allá del SLA de 3 días hábiles, o el envío del custodio falló de una manera que activa este mismo marcador.",
        "exampleTrigger": "Un depósito ha permanecido en estado Listo durante más de 3 días hábiles sin progresar."
      },
      "FAILED_ACCOUNT": {
        "description": "La configuración o el aprovisionamiento de la cuenta falló a mitad del proceso, por lo que necesita un seguimiento operativo para resolverse.",
        "exampleTrigger": "La creación de la cuenta se completa en la plataforma, pero el paso de incorporación del custodio devuelve un estado de fallo."
      },
      "FAILED_CUSTODIAN_OPENING": {
        "description": "La apertura de cuenta del custodio (o, en algunos casos, el envío de transferencia) devuelve una lista de tareas pendientes en lugar de confirmar que la cuenta fue abierta.",
        "exampleTrigger": "La apertura de cuenta del custodio devuelve una lista de tareas pendientes en lugar de un estado completado, por lo que se activa el marcador."
      },
      "FAILED_CUSTODIAN_ACCOUNT_OPENING": {
        "description": "El envío de la solicitud de apertura de cuenta del custodio falló (excepción / apertura fallida), por lo que no se estableció ninguna cuenta de custodio confirmada.",
        "exampleTrigger": "La solicitud de apertura de cuenta del custodio falla con un tiempo de espera de conexión, por lo que no se estableció ninguna cuenta confirmada y se activa el marcador."
      },
      "ACCOUNT_CLOSED": {
        "description": "Los datos del custodio indican que la cuenta en cuestión está CERRADA, mientras que la plataforma la muestra como ACTIVA.",
        "exampleTrigger": "La cuenta 12345678 está marcada como CERRADA según los datos del custodio, la plataforma sigue mostrando la cuenta 12345678 como ACTIVA."
      },
      "TOTAL_MARKET_VALUE_INCORRECT": {
        "description": "El valor de mercado de una cuenta en la plataforma ha caído más del umbral configurado (15% por defecto) en comparación con la instantánea de reconciliación del día anterior; los aumentos no activan este marcador. Las organizaciones pueden establecer su propio umbral (5% mínimo) o desactivar el marcador por completo para una conexión de custodio.",
        "exampleTrigger": "El valor de mercado de la plataforma era de $100,000 el día anterior y de $80,000 hoy — una caída del 20% — lo que excede el umbral de la organización (15% por defecto), por lo que se activa el marcador."
      },
      "STATEMENT_NOT_FOUND": {
        "description": "No se encontró un estado de cuenta para el mes anterior, a pesar de que la cuenta aún muestra valor de mercado en la plataforma.",
        "exampleTrigger": "La cuenta 98765432 tiene un valor de mercado de $12,500 pero no tiene estado de cuenta para junio de 2026."
      },
      "CASH_NOT_FOUND": {
        "description": "Discrepancia entre los datos del custodio y los datos de la plataforma con respecto a la cuenta de efectivo.",
        "exampleTrigger": "El custodio informa un saldo de cuenta de efectivo para la cuenta 12345678, la plataforma no tiene un registro de cuenta de efectivo para la cuenta."
      },
      "HOLDING_NOT_FOUND": {
        "description": "El custodio informa una posición para una cuenta que no tiene una posición coincidente en los registros de la plataforma.",
        "exampleTrigger": "El custodio informa 200 acciones del símbolo XYZ para una cuenta, pero la plataforma no muestra ninguna posición en ese símbolo."
      },
      "HOLDING_NOT_FOUND_IN_CUSTODIAN": {
        "description": "Existe una posición en los registros de la plataforma para una cuenta, pero las posiciones del custodio no incluyen una posición coincidente.",
        "exampleTrigger": "La plataforma muestra 100 acciones del símbolo ABC para una cuenta, pero las posiciones del custodio no listan ese símbolo."
      },
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": {
        "description": "Después de la reconciliación de la cuenta de efectivo, el dinero disponible en los datos del custodio y en la plataforma no coincide.",
        "exampleTrigger": "Los datos del custodio muestran un dinero disponible de $100.00 y la plataforma muestra $95.00."
      },
      "DIFFERENT_HOLDINGS_V2": {
        "description": "Al conciliar las posiciones entre el custodio y la plataforma, la cantidad difiere para un activo dado.",
        "exampleTrigger": "Los datos del custodio muestran 100 acciones de XYZ, mientras que la plataforma muestra 90 acciones."
      },
      "NEGATIVE_CASH": {
        "description": "El saldo de la cuenta de efectivo de una cuenta en la plataforma ha caído por debajo de cero, basándose en los propios registros de la plataforma en lugar de una comparación con los datos del custodio.",
        "exampleTrigger": "El saldo de la cuenta de efectivo de una cuenta en la plataforma se vuelve negativo después de que se liquida una operación, basándose únicamente en los propios registros de la plataforma."
      },
      "NEGATIVE_HOLDING": {
        "description": "La cantidad de acciones o unidades de una posición de seguridad en la plataforma se registra como un número negativo, basándose en los propios registros de posiciones de la plataforma en lugar de una comparación con los datos del custodio.",
        "exampleTrigger": "La cantidad de una posición para un símbolo en la plataforma se registra como menos de cero, basándose únicamente en los propios registros de la plataforma."
      },
      "PENDING_TRANSACTION_MONEY_AVAILABLE_VALUE_INCORRECT": {
        "description": "Igual que Dinero Disponible Incorrecto V2, pero la comparación utiliza el dinero disponible ajustado por transacciones pendientes.",
        "exampleTrigger": "Después de ajustar por operaciones pendientes, la plataforma muestra $5,000 disponibles, pero la instantánea del custodio implica $5,200."
      },
      "PENDING_TRANSACTION_DIFFERENT_HOLDINGS": {
        "description": "Igual que Diferentes Posiciones V2, pero la cantidad de la plataforma se ajusta por transacciones pendientes antes de compararla con la del custodio.",
        "exampleTrigger": "Después de las ventas pendientes, la plataforma proyecta 50 acciones del símbolo ABC, pero los datos del custodio aún muestran 60 acciones."
      },
      "DIFFERENT_BOOKVALUE": {
        "description": "El valor contable entre el custodio y la plataforma no coincide.",
        "exampleTrigger": "Los datos del custodio muestran un valor contable de $1,000 y el valor contable de la plataforma es de $1,050 para un activo en particular."
      },
      "NO_SNAPSHOTS_RECEIVED": {
        "description": "La plataforma no generó una instantánea diaria para una subcuenta en la fecha esperada. Esto es un indicador de que los datos del custodio no llegaron o no se procesaron a tiempo; verifica la salida de la propia instantánea de la plataforma, no el archivo del custodio en sí.",
        "exampleTrigger": "Una subcuenta no tiene una instantánea diaria para la fecha esperada, aunque se espera una, a menudo porque los datos del custodio no llegaron o no se procesaron a tiempo."
      },
      "SNAPSHOT_MISSING": {
        "description": "Una subcuenta tuvo una instantánea diaria el día anterior, pero no se registró ninguna instantánea para ella hoy.",
        "exampleTrigger": "Una subcuenta tenía datos de instantánea diaria ayer, pero hoy no se registró ninguno para ella."
      },
      "SNAPSHOT_ANOMALY": {
        "description": "Las cifras de contribución de una instantánea diaria no cuadran: en la primera instantánea de una cuenta, el valor de mercado, la contribución neta y la nueva contribución no coinciden entre sí; en instantáneas posteriores, la nueva contribución registrada no coincide con el cambio real día a día en la contribución neta.",
        "exampleTrigger": "La contribución neta de ayer fue de $1,000 y la de hoy es de $1,100 (un cambio de $100), pero la nueva contribución registrada del día es de solo $50."
      },
      "SNAPSHOT_PRICE_NOT_FOUND": {
        "description": "Una instantánea necesita un precio de mercado para valorar una posición, pero no se pudo encontrar ningún precio para esa fecha.",
        "exampleTrigger": "Una instantánea incluye una posición en el símbolo XYZ, pero no hay precio de mercado disponible para valorarla en esa fecha."
      },
      "NOT_ENOUGH_MONEY_AVAILABLE_IN_ACCOUNT": {
        "description": "No se puede procesar un retiro total porque el dinero disponible en la cuenta, después de sumar cualquier saldo disponible negativo, es insuficiente.",
        "exampleTrigger": "Se intenta un retiro total de $5,000 en una cuenta, pero la cuenta (incluidas sus subcuentas) tiene un dinero disponible de solo $4,500."
      },
      "RISKY_DIFFERENT_HOLDING_MF_SELL_ALL": {
        "description": "Para una operación de venta total de fondos mutuos, la cantidad que espera la plataforma y la cantidad que informa el custodio difieren en al menos un 10%.",
        "exampleTrigger": "La venta total espera una cantidad de 100, pero la cantidad de actividad es 85 (15% de discrepancia)."
      },
      "RISKY_DIFFERENT_HOLDING_USD_ETF": {
        "description": "Para una operación de ETF en USD, el valor que espera la plataforma y el valor que informa el custodio (cantidad × precio) difieren en al menos un 10%.",
        "exampleTrigger": "La operación asignó $10,000, pero el valor de ejecución es de $8,500 (15% de discrepancia de valor)."
      }
    }
  },
  "flagsMovedModal": {
    "title": "Los marcadores se han movido",
    "body": "Los marcadores ahora residen en su propio panel con nuevos filtros, resúmenes y una vista detallada. Será redirigido(a) allí ahora.",
    "confirm": "Ir a Marcadores"
  },
  "activitiesMovedModal": {
    "title": "Las actividades se han movido",
    "body": "Las actividades ahora residen en su propio panel con métricas y una lista de trabajo rediseñada. Será redirigido(a) allí ahora.",
    "confirm": "Ir a Actividades"
  },
  "activitiesV3": {
    "pageTitle": "Actividades",
    "pageSubtitle": "Supervise las métricas y el trabajo pendiente de la reconciliación de actividades del custodio.",
    "tablePlaceholder": "Lista de trabajo de actividades próximamente",
    "metrics": {
      "error": "No se pudieron cargar las métricas de actividad.",
      "occurringToday": {
        "title": "Ocurriendo hoy",
        "hint": "Actividades que ocurren hoy (UTC)"
      },
      "created": {
        "title": "Creado",
        "hint": "Trabajo pendiente (todo el tiempo)"
      },
      "reconciledToday": {
        "title": "Reconciliado hoy",
        "hint": "Reconciliado hoy (UTC)"
      },
      "agingPending": {
        "title": "Antigüedad pendiente",
        "hint": "Pendiente 3+ días (UTC)"
      }
    },
    "filters": {
      "state": "Estado",
      "stateCreated": "Creado",
      "stateReconciledToday": "Reconciliado (hoy)",
      "type": "Tipo",
      "aging": "Antigüedad",
      "any": "Cualquiera",
      "agingOneDay": "1+ día(s)",
      "agingThreeDays": "3+ día(s)",
      "agingSevenDays": "7+ día(s)",
      "search": "Buscar",
      "searchPlaceholder": "Cliente, n.º de cuenta o ticker",
      "clearFilters": "Borrar filtros",
      "expandAll": "Expandir todo",
      "collapseAll": "Contraer todo"
    },
    "table": {
      "client": "Cliente",
      "organization": "Organización",
      "date": "Fecha",
      "type": "Tipo",
      "custodianAcct": "Cuenta de custodio",
      "amount": "Importe",
      "acctType": "Tipo de cuenta",
      "state": "Estado",
      "aging": "Antigüedad",
      "reconciledVia": "Reconciliado vía",
      "empty": "Ninguna actividad coincide con los filtros actuales.",
      "ticker": "Símbolo bursátil"
    },
    "bulk": {
      "selectedCount": "{{count}} seleccionado(s)",
      "selectAllOnPage": "Seleccionar todo en la página",
      "clearSelection": "Borrar selección",
      "retry": "Reintentar en masa"
    },
    "detail": {
      "tabs": {
        "details": "Detalles",
        "account": "Cuenta",
        "flags": "Marcadores",
        "notes": "Notas",
        "raw": "JSON sin procesar"
      },
      "sections": {
        "general": "General",
        "transaction": "Transacción",
        "securityTrade": "Seguridad y Operación"
      },
      "fields": {
        "processDate": "Fecha de proceso",
        "effectiveDate": "Fecha de entrada en vigor",
        "settleDate": "Fecha de liquidación",
        "accountType": "Tipo de cuenta",
        "custodianAccountNumber": "Número de cuenta de custodio",
        "isCancel": "Cancelado",
        "transactionDesc": "Descripción",
        "transactionId": "ID de transacción",
        "subTransactionId": "ID de subtransacción",
        "symbol": "Símbolo",
        "securityType": "Tipo de seguridad",
        "quantity": "Cantidad",
        "priceCents": "Precio",
        "commission": "Comisión",
        "accruedInterest": "Intereses devengados",
        "bookValueAmountCents": "Valor contable",
        "cusip": "Código CUSIP"
      },
      "yes": "Sí",
      "amountSummary": "Importe",
      "placeholders": {
        "account": "La instantánea de la cuenta se cargará aquí en una versión posterior.",
        "flags": "Los marcadores vinculados se cargarán aquí en una versión posterior.",
        "notes": "El historial de notas y la opción de guardar estarán disponibles en una versión posterior. Su borrador se conservará si contrae esta fila."
      },
      "notes": {
        "draftPlaceholder": "Añadir un borrador de nota…",
        "composePlaceholder": "Añada notas sobre su investigación…",
        "save": "Guardar",
        "saved": "Notas guardadas",
        "saveError": "No se pudieron guardar las notas",
        "historyEmptyTitle": "Aún no hay notas",
        "historyEmptyReadOnlyTitle": "No hay notas para esta actividad",
        "historyEmptyDescription": "Añada una nota para capturar contexto importante sobre esta actividad.",
        "cleared": "Liquidado"
      },
      "raw": {
        "copy": "Copiar JSON"
      },
      "footer": {
        "retry": "Reintentar",
        "retryFailed": "Reintento fallido. Inténtelo de nuevo.",
        "dismiss": "Descartar",
        "moreActions": "Más acciones",
        "readOnly": "Esta actividad ya está reconciliada ({{method}})."
      },
      "dismissModal": {
        "title": "¿Descartar actividad?",
        "body": "Descartar marca esta actividad como reconciliada sin vincular una transacción interna. Esto no se puede deshacer desde esta pantalla.",
        "confirm": "Descartar",
        "cancel": "Cancelar"
      },
      "flags": {
        "empty": "No hay marcadores vinculados a esta actividad.",
        "error": "No se pudieron cargar los marcadores para esta actividad.",
        "summary": "{{total}} marcadores · {{active}} activos",
        "capped": "mostrando {{cap}} de {{total}}",
        "incomplete": "Algunos marcadores de actividad no pudieron cargarse.",
        "openInFlagRecon": "Abrir marcadores",
        "columns": {
          "type": "Tipo",
          "category": "Categoría",
          "priority": "Prioridad",
          "state": "Estado",
          "firstSeen": "Visto por primera vez",
          "notes": "Notas"
        }
      },
      "account": {
        "empty": "No hay instantánea de reconciliación disponible para esta cuenta.",
        "dayEmpty": "No hay instantánea de reconciliación para esta fecha.",
        "error": "No se pudo cargar la instantánea de la cuenta.",
        "openInRecon": "Abrir en Reconciliación de Cuentas →",
        "banner": {
          "tiesOut": "La cuenta cuadra",
          "doesNotTieOut": "La cuenta no cuadra",
          "awaitingCustodian": "Aún no comparable — esperando datos del custodio",
          "awaitingSystem": "Aún no comparable — esperando datos del sistema",
          "awaitingBoth": "Aún no comparable — esperando datos del sistema y del custodio",
          "asOf": "A partir del {{date}}"
        },
        "asOf": {
          "title": "Instantánea — a partir de",
          "prev": "Día de instantánea anterior",
          "next": "Día de instantánea siguiente",
          "diverged": "Viendo una instantánea anterior ·",
          "reset": "Restablecer a la última"
        },
        "diff": {
          "security": "Seguridad",
          "systemQty": "Cantidad del sistema",
          "custodianQty": "Cantidad del custodio",
          "deltaQty": "Δ cantidad",
          "systemValue": "Valor del sistema",
          "custodianValue": "Valor del custodio",
          "deltaValue": "Δ valor",
          "pending": "pendiente",
          "cash": "Cuenta de Efectivo",
          "empty": "No hay posiciones en la instantánea seleccionada."
        },
        "narrative": {
          "tiesOut": "La cuenta cuadra en la última instantánea — este {{type}} ya está reflejado.",
          "securityGap": "Reconciliar este {{type}} puede cerrar parte de la brecha de cantidad de {{ticker}}.",
          "cashPending": "La brecha de efectivo para este {{type}} incluye importes en curso pendientes de nuestra parte.",
          "cashGap": "Reconciliar este {{type}} debería eliminar la brecha de efectivo en la última instantánea.",
          "genericBreak": "Este {{type}} puede estar relacionado con la ruptura de la cuenta en la última instantánea."
        }
      },
      "no": "Falso"
    }
  }
}
